var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProfileSettings = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.063 11.93c0-2.076 1.707-3.766 3.82-3.766 2.114 0 3.821 1.69 3.821 3.767 0 2.076-1.707 3.766-3.82 3.766-2.114 0-3.822-1.69-3.822-3.766Zm6.898 0c0-1.675-1.384-3.023-3.078-3.023s-3.077 1.348-3.077 3.024c0 1.675 1.384 3.023 3.077 3.023 1.695 0 3.078-1.347 3.078-3.023Z",
  fill: "#000",
  stroke: "#000"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m19.433 18.107.004.006.004.007c.026.042.044.089.052.138l.493-.08-.493.08a.372.372 0 0 1-.319.428l.065.495-.065-.495a.372.372 0 0 1-.279-.078l-.31.392.31-.392a.372.372 0 0 1-.095-.112l-.004-.007-.003-.006a5.685 5.685 0 0 0-4.909-2.787 5.685 5.685 0 0 0-4.908 2.787l-.006.01a.372.372 0 0 1-.096.112l.309.393-.309-.393a.372.372 0 0 1-.545-.488l.006-.01a6.427 6.427 0 0 1 5.55-3.154 6.427 6.427 0 0 1 5.548 3.154Z",
  fill: "#000",
  stroke: "#000"
})));
export default SvgProfileSettings;